
import { NgModule, Directive, ElementRef } from '@angular/core';
@Directive({
  selector: '[appScrollbarTheme]'
})
export class ScrollbarThemeDirective {
  constructor(el: ElementRef) {
    const stylesheet = `
    ::-webkit-scrollbar {
      width: 5px;
      }
      ::-webkit-scrollbar-track {
      background: #fff;
      }
      ::-webkit-scrollbar-thumb {
      border-radius: 1rem;
      background: #c5c5c5;
     
      }
      ::-webkit-scrollbar-thumb:hover {
        cursor:pointer;
      }
    `;

    const styleElmt = el.nativeElement.shadowRoot.querySelector('style');

    if (styleElmt) {
      styleElmt.append(stylesheet);
    } else {
      const barStyle = document.createElement('style');
      barStyle.append(stylesheet);
      el.nativeElement.shadowRoot.appendChild(barStyle);
    }

  }
}


@NgModule({
  declarations: [ ScrollbarThemeDirective ],
  exports: [ ScrollbarThemeDirective ]
})
export class ScrollbarThemeModule {}